import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Entite } from '@Common/core/services';
import { EntiteService } from '@Common/core/services';

@Component({
  selector: 'app-search-entite',
  templateUrl: './search-entite.component.html',
  styleUrls: ['./search-entite.component.css']
})
export class SearchEntiteComponent implements OnInit {
  entitesList: Entite [];
  entiteSelected: Entite;

  svcdepList: Entite[];
  svcdepSelected: Entite;

  typeEntite = '';

  labelDirCmp = '';
  labelSvcDep = '';

  badgeDir = '';
  badgeCmp = '';

  constructor(
    public dialogRef: MatDialogRef<SearchEntiteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private entiteService: EntiteService) { }

  ngOnInit() {

  }

  private sortByName(data) {
    data.sort((a: Entite, b: Entite) =>  (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
  }

  private excludeChildZero(data: any[]) {
    return data.filter((_data: Entite) => _data.numchild > 0);
  }

  onComposanteSelected(event) {
    this.labelDirCmp = 'Sélectionner une composante';
    this.labelSvcDep = 'Sélectionner un département';
    this.badgeCmp = 'x';
    this.badgeDir = '';
    this.svcdepList = [];

    this.entiteService.listByType('cmp').subscribe(data => {
      // data = this.excludeChildZero(data);
      this.sortByName(data);
      this.entitesList = data;
      this.typeEntite = 'dep';
    });
  }

  onDirectionSelected(event) {
    this.labelDirCmp = 'Sélectionner une direction';
    this.labelSvcDep = 'Sélectionner un service';
    this.badgeCmp = '';
    this.badgeDir = 'x';
    this.svcdepList = [];

    this.entiteService.listByType('adm').subscribe(data => {
      data = this.excludeChildZero(data);
      this.sortByName(data);
      this.entitesList = data;
      this.typeEntite = 'adm';
    });
  }

  searchDepartement(composante: Entite) {
    if (this.typeEntite) {
      this.entiteService.listByParentAndType(composante.id, this.typeEntite).subscribe(data => {
        this.sortByName(data);
        this.svcdepList = data;
      });
    }
  }

  close() {
    this.dialogRef.close();
  }

  select() {
    const data = {
      dir_cmp: this.entiteSelected,
      svc_dep: this.svcdepSelected
    };
    this.dialogRef.close(data);
  }
}
